import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@repo/shadcn';
import { Home } from 'lucide-react';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

import { Route } from '@/constants';

type HeaderBreadcrumbProps = {
    items?: Array<{
        label: ReactNode;
        href?: string;
    }>;
    showHomeLink?: boolean;
};

export const HeaderBreadcrumb = ({
    items,
    showHomeLink = true,
}: HeaderBreadcrumbProps) => {
    return (
        <Breadcrumb>
            <BreadcrumbList>
                {showHomeLink && (
                    <Fragment>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to={Route.DASHBOARD}>
                                    <Home className={'size-4 text-black'} />
                                </Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        {items && items.length > 0 && <BreadcrumbSeparator />}
                    </Fragment>
                )}
                {items?.map((item, index) => {
                    const isLast = index === items.length - 1;
                    return (
                        <Fragment key={index}>
                            <BreadcrumbItem>
                                {item.href ? (
                                    <BreadcrumbLink asChild>
                                        <Link to={item.href}>{item.label}</Link>
                                    </BreadcrumbLink>
                                ) : (
                                    <BreadcrumbItem>
                                        <BreadcrumbPage>
                                            {item.label}
                                        </BreadcrumbPage>
                                    </BreadcrumbItem>
                                )}
                            </BreadcrumbItem>
                            {!isLast && <BreadcrumbSeparator />}
                        </Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
